import React, { useState ,useEffect } from "react";

import "./floatLabel.css";
import { type } from "os";

const FloatLabel = (props:{
  children: any,
  label: string,
  value: any,
  isMultiSelect?: boolean,
  reasontype?: any,
}) => {
  const [focus, setFocus] = useState(false);
  const { children, label, value } = props;

  const labelClass =
    focus || (value && value.length !== 0) ? "label label-float" : "label";

  const accessLabelClass= focus || (value && value.length !== 0) ? "access_label label-float" : "access_label";  

  const finalclass = props.reasontype=="accessReason"?accessLabelClass:labelClass;
    
  useEffect(() => {
    if (label ==="Reason *" ) {
      let val = value;
      // setFocus(true);
    }
  }, [label,value]);
  return (
    <div
      className="float-label"
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      {children}
      <label className={finalclass} style={!children.props.disabled?props.isMultiSelect?{width:'93%', background:'white',paddingTop:'5px'}:{}:{}}>{label}</label>
    </div>
  );
};

export default FloatLabel;